// @flow
import React from 'react';
import {connect} from 'react-redux';
import classNames from 'classnames';
import {Link} from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import {withStyles} from '@material-ui/core/styles';
import styles from './FeaturedVideos.styles.js';
import api from 'utils/API';
import {Image} from 'app/components/Image';
import {Icon} from 'app/components/Icon';

type Props = {
  classes: any
};

type State = {
  list: Array<any>
};

class FeaturedVideos extends React.Component<Props, State> {
  unmounted = false;
  
  constructor(props) {
    super(props);

    this.state = {list: []};
  }

  componentDidMount() {
    api.get('/multi-media/lastest_videos')
    .then(response => {
      if (this.unmounted) {
        return;
      }

      const list = response.data.list || [];
      // const list = responseList.map(item => {
      //   return item
        // return {...item, excerpt: truncate(item.excerpt, 50)};
      // });
      this.setState({list});
    });
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  render() {
    const {classes} = this.props;
    return (
      <div className={classes.wrapper}>
        <div className={classes.container}>
          <Grid container spacing={8}>
            {this.state.list.map(item => {
              return (
                <Grid key={item.id} item xs={6} md={2}>
                  <div className={classes.item}>
                    <Link to={`/${item.parent.name}`} className={classes.link}>
                      <Image
                        placeholder
                        cover
                        block
                        overlayShadow
                        component={"span"}
                        className={{root: classes.thumbnail}}
                        src={item.thumbnail}
                        alt={item.title}
                      />
                      <div className={classes.itemContainer}>
                        <Icon
                          name="play"
                          component="div"
                          className={classNames(classes.icon, 'featured-videos-icon')}
                        />
                        <div className={classes.content}>
                          {item.excerpt}
                        </div>
                      </div>
                    </Link>
                  </div>
                </Grid>
              );
            })}
          </Grid>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  list: state.FeaturedVideos
});

const Component = connect(mapStateToProps)(withStyles(styles)(FeaturedVideos));
export {Component as FeaturedVideos};
export default Component;